import { Group, GroupItem, GroupTitle } from "ra-friendsofbabba";
import React, { useCallback, useMemo } from "react";
import {
  Tab,
  TableContainer,
  Tabs,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";

import PropTypes from "prop-types";
import TableWrapper from "./crono/TableWrapper";
import theme from "../../theme";
import { useFormState } from "react-final-form";
import { useTranslate } from "react-admin";

const useStyles = makeStyles(() => ({
  div: {
    "& .MuiGrid-root": {
      [theme.breakpoints.down("xs")]: {
        width: "auto",
        margin: 0,
      },
    },
  },
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className={classes.div}
    >
      {value === index && <TableContainer>{children}</TableContainer>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CronoField = ({ wps, useValues = false, showSubTitle = true }) => {
  const translate = useTranslate();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const [value, setValue] = React.useState(0);
  const handleChange = useCallback((e, newValue) => {
    setValue(newValue);
  }, []);
  const { values } = useFormState({ subscription: { values: true } });
  const wpsData = useMemo(() => {
    let list = [].concat(wps || []);
    if (useValues) {
      if (values?.id > 0) {
        list = list.map((item) => (item?.id === values.id ? values : item));
      } else {
        list.push(values);
      }
    }
    return list;
  }, [wps, values, useValues]);

  return (
    <Group wrapper>
      <GroupTitle
        title={translate("resources.executive-projects.section.crono")}
        subTitle={
          showSubTitle
            ? translate("resources.executive-projects.section.crono.help")
            : null
        }
      />
      {isXs ? (
        <Group>
          <Group>
            <GroupItem>
              <Tabs value={value} onChange={handleChange}>
                <Tab label="1-6" {...a11yProps(0)} />
                <Tab label="7-12" {...a11yProps(1)} />
                <Tab label="13-18" {...a11yProps(2)} />
              </Tabs>
            </GroupItem>
          </Group>
          <Group>
            <GroupItem>
              <TabPanel value={value} index={0}>
                <TableWrapper wps={wpsData} from={0} to={6} />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <TableWrapper wps={wpsData} from={6} to={12} />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <TableWrapper wps={wpsData} from={12} to={18} />
              </TabPanel>
            </GroupItem>
          </Group>
        </Group>
      ) : (
        <TableWrapper wps={wpsData} from={0} to={18} />
      )}
    </Group>
  );
};
export default CronoField;
